export default {
  language: {
    zh_cn: '语言',
    en: 'Language',
    he: 'שפה',
    de: 'Sprache',
    es: 'Idioma',
    ru: 'Язык',
    vi: 'Ngôn ngữ',
  },
  languageTip: {
    zh_cn: '选择 Dashboard 页面内所展示的语言',
    en: 'Select the language displayed in the Dashboard page',
    he: 'בחר את השפה המוצגת בדף לוח הבקרה',
    de: 'Wählen Sie die auf der Dashboard-Seite angezeigte Sprache aus',
    es: 'Seleccione el idioma que se muestra en la página del panel de control',
    ru: 'Выберите язык, отображаемый на странице панели управления',
    vi: 'Chọn ngôn ngữ hiển thị trên trang bảng điều khiển',
  },
  theme: {
    zh_cn: '主题',
    en: 'Theme',
    he: 'ערכת נושא',
    de: 'Thema',
    es: 'Tema',
    ru: 'Тема',
    vi: 'Chủ đề',
  },
  themeTip: {
    zh_cn: 'Dashboard 的系统主题颜色，支持明亮和暗黑。当开启同步操作系统主题时，将无法手动切换主题',
    en: "Dashboard's system theme, supporting Light and Dark. When Sync OS theme is enabled, it will not be possible to switch themes manually",
    he: 'ערכת הנושא של מערכת לוח הבקרה, תומכת באור וחושך. כאשר סינכרון עם ערכת הנושא של מערכת ההפעלה מופעל, לא ניתן יהיה להחליף ערכות נושא ידנית',
    de: 'Systemthema des Dashboards, unterstützt hell und dunkel. Wenn die Synchronisierung mit dem Betriebssystemthema aktiviert ist, ist ein manuelles Umschalten der Themen nicht möglich',
    es: 'Tema del sistema del panel de control, compatible con Claro y Oscuro. Cuando la sincronización del tema del SO está habilitada, no será posible cambiar los temas manualmente',
    ru: 'Системная тема панели управления, поддерживающая светлую и темную темы. Когда включена синхронизация с темой ОС, переключение тем вручную будет невозможно',
    vi: 'Chủ đề hệ thống của bảng điều khiển, hỗ trợ chế độ Sáng và Tối. Khi chế độ Đồng bộ chủ đề hệ điều hành được bật, bạn sẽ không thể chuyển đổi chủ đề thủ công',
  },
  light: {
    en: 'Light',
    zh_cn: '明亮',
    he: 'בהיר',
    de: 'Hell',
    es: 'Claro',
    ru: 'Светлая',
    vi: 'Sáng',
  },
  dark: {
    en: 'Dark',
    zh_cn: '暗黑',
    he: 'כהה',
    de: 'Dunkel',
    es: 'Oscuro',
    ru: 'Темная',
    vi: 'Tối',
  },
  syncOsTheme: {
    zh_cn: '同步操作系统主题',
    en: 'Sync OS Theme',
    he: 'סנכרון ערכת נושא מערכת ההפעלה',
    de: 'OS-Thema synchronisieren',
    es: 'Sincronizar tema del SO',
    ru: 'Синхронизация темы ОС',
    vi: 'Đồng bộ chủ đề hệ điều hành',
  },
  syncOsThemeTip: {
    zh_cn: '开启后，系统将跟随操作系统主题自动切换',
    en: 'Automatically switch between Light and Night themes when your system does.',
    he: 'כאשר מופעל, המערכת תעבור אוטומטית בין ערכות הנושא של אור ולילה כאשר המערכת שלך עושה זאת.',
    de: 'Automatisches Umschalten zwischen Licht- und Nachtmodus, wenn Ihr System dies tut.',
    es: 'Cambia automáticamente entre los temas Claro y Noche cuando tu sistema lo haga.',
    ru: 'Автоматически переключаться между светлой и ночной темами, когда ваша система делает это.',
    vi: 'Tự động chuyển đổi giữa các chủ đề Sáng và Tối khi hệ thống của bạn chuyển đổi.',
  },
  gettingStarted: {
    zh_cn: 'EVCC 快速入门指南',
    en: 'EVCC Getting Started Guide',
    he: 'מדריך התחלה מהירה EVCC',
    de: 'EVCC Schnellstartanleitung',
    es: 'Guía de inicio rápido de EVCC',
    ru: 'Руководство по быстрому старту EVCC',
    vi: 'Hướng dẫn bắt đầu nhanh EVCC',
  },
  dashboardIntro: {
    zh_cn: 'EVCC Dashboard 介绍',
    en: 'EVCC Dashboard Introduction',
    he: 'הקדמה ללוח הבקרה של EVCC',
    de: 'Einführung in das EVCC-Dashboard',
    es: 'Introducción al panel de control de EVCC',
    ru: 'Введение в панель управления EVCC',
    vi: 'Giới thiệu bảng điều khiển EVCC',
  },
  howAccessControl: {
    zh_cn: '如何进行访问控制',
    en: 'How to implement Access Control',
    he: 'כיצד ליישם בקרת גישה',
    de: 'Wie man Zugangskontrolle implementiert',
    es: 'Cómo implementar el control de acceso',
    ru: 'Как реализовать контроль доступа',
    vi: 'Cách thực hiện kiểm soát truy cập',
  },
  howDataIntegration: {
    zh_cn: '如何使用数据集成',
    en: 'How to use Data Integration',
    he: 'כיצד להשתמש באינטגרציית נתונים',
    de: 'Wie man Datenintegration verwendet',
    es: 'Cómo usar la integración de datos',
    ru: 'Как использовать интеграцию данных',
    vi: 'Cách sử dụng tích hợp dữ liệu',
  },
  howRuleEngine: {
    zh_cn: '如何使用规则引擎',
    en: 'How to use Rule Engine',
    he: 'כיצד להשתמש במנוע כללים',
    de: 'Wie man die Regel-Engine verwendet',
    es: 'Cómo usar el motor de reglas',
    ru: 'Как использовать движок правил',
    vi: 'Cách sử dụng công cụ quy tắc',
  },
  faq: {
    zh_cn: '常见问题解答',
    en: 'FAQ',
    he: 'שאלות נפוצות',
    de: 'FAQ',
    es: 'FAQ',
    ru: 'Часто задаваемые вопросы',
    vi: 'Câu hỏi thường gặp',
  },
}
